import loadable from '@loadable/component';

import { CmsApiSupportContactFormBlockData } from 'modules/cms/api/types/blocks/CmsApiSupportContactFormBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

export const CmsSupportContactFormBlockMapping: CmsBlockMapping<CmsApiSupportContactFormBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.FULL,
    Component: loadable(() => import('./CmsSupportContactFormBlock'), {
      resolveComponent: (module) => module.CmsSupportContactFormBlock,
    }),
  };
